import React from 'react';
import { AxiosError, AxiosResponse } from 'axios';
import { Grid } from '@material-ui/core';

import { RevisionContext } from '../RevisionContext';
import { HomeContext } from '../../../Home/HomeContext';
import { BasicConfirmDialog } from '../../../../shared/components/BasicConfirmDialog';
import { theme } from '../../../../theme';
import { OrganogramDto } from '../../../../Models/OrganogramDto';
import OrganogramService from '../../../../Services/OrganogramService';
import { organogramBatchModelInitial } from '../../../../Models/OrganogramBatchModel';
import CategoryOrganogramService from '../../../../Services/CategoryOrganogramService';
import { OrganogramsContext } from '../../../../shared/context/OrganogramsContext';
import { Organogram } from '../../../../shared/components/Organogram';
import { BatchCorrectionContext } from '../BatchCorrectionContext';

export function OrganogramBatchCorrection() {

    const revisionContext = React.useContext(RevisionContext);
    const homeContext = React.useContext(HomeContext);
    const batchCorrectionContext = React.useContext(BatchCorrectionContext);

    const [organogramDto, setOrganogramDto] = React.useState<OrganogramDto[]>([]);

    const [organogramError, setOrganogramError] = React.useState(false);

    React.useEffect(() => {
        if (revisionContext.filterClassification.clientId != null && revisionContext.organogramBatchOpenDialog) {
            OrganogramService.organogramService(revisionContext.filterClassification.clientId)
                .getAll()
                .then((res: AxiosResponse) => {
                    const organogramsDto: OrganogramDto[] = [{
                        level: 1,
                        parentId: null,
                        selectedOrganogram: null,
                        hasOrganograms: false,
                        organogramList: res.data
                    }];
                    setOrganogramDto(organogramsDto);
                })
                .catch((error: AxiosError) => {
                    homeContext.showError('', error);
                });
        }
    }, [revisionContext.organogramBatchOpenDialog]);

    const hasError = () => {
        const errorOrganogram = organogramDto.filter((e: OrganogramDto) =>
            (e.selectedOrganogram == null) && (e.organogramList.length > 0)).length > 0;

        setOrganogramError(errorOrganogram);

        return (errorOrganogram);
    };

    const updateOrganogramBatch = () => {
        if (!hasError() && organogramDto && organogramDto.length > 1) {
            homeContext.setOpenLoadingDialog(true);

            const organogramData = { ...organogramBatchModelInitial };
            organogramData.categoriesId = revisionContext.ids;
            const organogramList = JSON.parse(JSON.stringify(organogramDto));

            organogramData.organograms = organogramList;

            CategoryOrganogramService.categoryOrganogramBatch(organogramData)
                .then(() => {
                    clearModalOrganogram();
                    homeContext.setOpenLoadingDialog(false);
                    homeContext.showSuccess(`As alterações foram realizadas para todas as ${revisionContext.ids.length} categorizações selecionadas com sucesso!`);
                    batchCorrectionContext.setCallSearch(true);
                })
                .catch((error: any) => {
                    const message = 'Ops... Ocorreu um erro e não foi possível salvar as alterações. ';

                    if (error.data.errors[0].property == 'DuplicatedOrganogram')
                        homeContext.showError(message, error);
                    else
                        homeContext.showError(message + 'Por favor, tente novamente dentro de alguns instantes. <br/>', error);

                    homeContext.setOpenLoadingDialog(false);
                });
        }
    };

    const clearModalOrganogram = () => {
        revisionContext.setOrganogramBatchOpenDialog(false);
        setOrganogramDto([]);
        setOrganogramError(false);
    };

    const getOrganogram = () => {
        return (
            <Grid
                container
                spacing={3}>
                <OrganogramsContext.Provider value={{
                    organogramDto, setOrganogramDto
                }}>
                    {organogramDto.map((item: OrganogramDto) =>
                        <Grid
                            key={`grid-organogram-${item.parentId}-${item.selectedOrganogram ? item.selectedOrganogram.id : 0}`}
                            item
                            xs={12}
                            sm={6}>
                            <Organogram
                                key={`organogram-${item.parentId}-${item.selectedOrganogram ? item.selectedOrganogram.id : 0}`}
                                level={item.level}
                                error={organogramError}
                                parentId={item.parentId}
                                selected={item.selectedOrganogram}
                                organogramsList={item.organogramList} />
                        </Grid>
                    )}
                </OrganogramsContext.Provider>
            </Grid>
        );
    };

    return (
        <BasicConfirmDialog
            title={'Alteração de organograma'}
            description={'Altere os campos para alterar o organograma'}
            handleFirstButton={() => clearModalOrganogram()}
            handleSecondButton={() => updateOrganogramBatch()}
            textFirstButton='DESCARTAR'
            textSecondButton='SALVAR'
            open={revisionContext.organogramBatchOpenDialog}
            children={getOrganogram()}
            cssProperties={{
                minWidth: '900px',
                maxWidth: '1200px',
                padding: '1rem',
                colorFirstButton: theme.palette.primary.main,
                justifyButtons: 'flex-end',
                titleVariant: 'h4',
                descriptionVariant: 'body1'
            }} />
    );
}